import { DEFAULT_LIMIT, fetchAllCursorPages, schedulingDelete, schedulingGet, schedulingPost, schedulingPut } from "./client";

export function listBlocks({
  organizationRef,
  blockId,
  scheduleId,
  practitionerRef,
  startsAt,
  endsAt,
  status,
  cursor,
  limit = DEFAULT_LIMIT,
  signal,
  consistency,
}) {
  return schedulingGet("block", {
    organizationRef,
    blockId,
    scheduleId,
    practitionerRef,
    startsAt,
    endsAt,
    status,
    cursor,
    limit,
  }, { signal, consistency });
}

export async function listAllBlocks(params) {
  return fetchAllCursorPages({
    signal: params.signal,
    itemsKey: "blocks",
    fetchPage: (cursor) => listBlocks({ ...params, cursor }),
  });
}

export function createBlock(body) {
  return schedulingPost("block", body);
}

export function updateBlock(body) {
  return schedulingPut("block", body);
}

export function releaseBlock({ organizationRef, blockId }) {
  return schedulingDelete("block", { organizationRef, blockId });
}
